/* What the three XYZ views' view models share: the streams they derive from and the part of the
 * settings that can move a point. The dispatches they make off the result live in
 * `tabview/chartShared/plottedViewEffects`, which the radial views use too.
 */

import type { XyzFieldSelection } from '@ardoq/xyz-charts';
import { context$ } from 'streams/context/context$';
import { loadedGraph$ } from 'traversals/loadedGraph$';
import { currentUserPermissionContext$ } from 'streams/currentUserPermissions/currentUserPermissionContext$';
import { locale$ } from 'streams/locale$';
import { i18nLocale$ } from 'streams/i18nLocale$';
import { formattingAndLabelRules$ } from 'streams/filters/formattingAndLabelRules$';
import { narrowToPlottedContext } from '../sourceData/plottedContext';

/** The inputs every XYZ derivation reads, minus the settings each one narrows for itself. */
export const XYZ_DERIVATION_INPUTS = {
  context: context$.pipe(narrowToPlottedContext()),
  loadedGraph: loadedGraph$,
  permissionContext: currentUserPermissionContext$,
  locale: locale$,
  i18nLocale: i18nLocale$,
  formattingAndLabelRules: formattingAndLabelRules$,
};

/**
 * The part of a chart's settings that can move a point.
 *
 * Only these five reach the derivation; the view follows every settings write on its own branch.
 * `xyzDerivation.test.ts` pins that split.
 */
export const toXyzFieldSelection = ({
  selectedFieldNameX,
  selectedFieldNameY,
  selectedFieldNameZ,
  selectedFieldNameRadius,
  selectedFieldNameColor,
}: XyzFieldSelection): XyzFieldSelection => ({
  selectedFieldNameX,
  selectedFieldNameY,
  selectedFieldNameZ,
  selectedFieldNameRadius,
  selectedFieldNameColor,
});
